import styled from 'styled-components';

import { PrimaryTextColor } from './colors';

export const Body1 = styled.span`
  color: ${PrimaryTextColor};
  font-size: 11px;
  line-height: 24px;
`;
